import React from 'react';

type Event = React.MouseEvent;
export type WrappedEvent = {
  domEvent: { stopPropagation: Event['stopPropagation'] };
};
export type GenericEvent = Event | WrappedEvent;

const isEvent = (e: GenericEvent): e is Event =>
  (e as Event).stopPropagation !== undefined;

const isWrappedEvent = (e: GenericEvent): e is WrappedEvent =>
  (e as WrappedEvent).domEvent !== undefined;

export const unifiedStopPropagation = (e: Event | WrappedEvent) => {
  if (isEvent(e)) e.stopPropagation();

  if (isWrappedEvent(e)) e.domEvent.stopPropagation();
};
